'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Subtitle1", {
    enumerable: true,
    get: function() {
        return Subtitle1;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useSubtitle1Stylesstyles = require("./useSubtitle1Styles.styles");
const Subtitle1 = (0, _createPreset.createPreset)({
    useStyles: _useSubtitle1Stylesstyles.useSubtitle1Styles,
    className: _useSubtitle1Stylesstyles.subtitle1ClassNames.root,
    displayName: 'Subtitle1'
});
